import { translate } from '../i18n';

const BIRTHDATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const MIN_BIRTH_YEAR = 1900;
const MIN_HEIGHT = 80;
const MAX_HEIGHT = 250;

export function formatPhoneInput(value) {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (!digits) return '';

  if (digits.startsWith('02')) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    if (digits.length <= 9) {
      return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
    }
    return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
  }

  if (digits.startsWith('010')) {
    if (digits.length <= 3) return digits;
    if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
  }

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length <= 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
}

export function validatePhone(phone, label = translate('registration.validation.phoneLabel')) {
  const digits = phone.replace(/\D/g, '');

  if (!digits) {
    return { valid: false, message: translate('registration.validation.phoneRequired', { label }) };
  }

  const isMobile = /^01[016789]\d{7,8}$/.test(digits);
  const isLandline = /^0[2-6][0-9]\d{6,8}$/.test(digits);

  if (!isMobile && !isLandline) {
    return {
      valid: false,
      message: translate('registration.validation.phoneInvalid', { label }),
    };
  }

  if (digits.length < 9 || digits.length > 11) {
    return {
      valid: false,
      message: translate('registration.validation.phoneInvalid', { label }),
    };
  }

  return { valid: true, digits };
}

export function validateBirthdate(birthdate) {
  if (!birthdate?.trim()) {
    return { valid: false, message: translate('registration.validation.birthRequired') };
  }

  const match = birthdate.trim().match(BIRTHDATE_PATTERN);
  if (!match) {
    return {
      valid: false,
      message: translate('registration.validation.birthFormat'),
    };
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const currentYear = new Date().getFullYear();

  if (year < MIN_BIRTH_YEAR || year > currentYear) {
    return {
      valid: false,
      message: translate('registration.validation.birthYearRange', {
        min: MIN_BIRTH_YEAR,
        max: currentYear,
      }),
    };
  }

  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return {
      valid: false,
      message: translate('registration.validation.birthMonthDay'),
    };
  }

  const parsed = new Date(year, month - 1, day);
  if (
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return {
      valid: false,
      message: translate('registration.validation.birthNotExist'),
    };
  }

  const today = new Date();
  today.setHours(23, 59, 59, 999);
  if (parsed > today) {
    return {
      valid: false,
      message: translate('registration.validation.birthFuture'),
    };
  }

  return { valid: true };
}

export function validateHeight(height) {
  if (height === '' || height == null) {
    return { valid: false, message: translate('registration.validation.heightRequired') };
  }

  const value = Number(height);
  if (Number.isNaN(value)) {
    return { valid: false, message: translate('registration.validation.heightNumber') };
  }

  if (value > MAX_HEIGHT) {
    return { valid: false, message: translate('registration.validation.heightMax', { max: MAX_HEIGHT }) };
  }

  if (value < MIN_HEIGHT) {
    return { valid: false, message: translate('registration.validation.heightMin', { min: MIN_HEIGHT }) };
  }

  return { valid: true, value };
}

export function getBirthdateInputBounds() {
  const today = new Date();
  const max = today.toISOString().slice(0, 10);
  return { min: `${MIN_BIRTH_YEAR}-01-01`, max };
}
